import { Lightbulb } from "@phosphor-icons/react";
import PlanejamentoDocModule from "./PlanejamentoDocModule";

export default function ETP() {
  return (
    <PlanejamentoDocModule
      endpoint="etps"
      title="ETP — Estudo Técnico Preliminar"
      subtitle="Etapa 2 · Planejamento"
      baseLegal="Lei 14.133/2021 · art. 18, §1º"
      Icon={Lightbulb}
      acentoColor="#FFDF00"
      promoverLabel="Promover para TR"
      promoverPath="/etps/{id}/promover-tr"
      nextRoute="/trs"
    />
  );
}
